import { render, staticRenderFns } from "./ProjectCreateModel.vue?vue&type=template&id=49b97b01&scoped=true"
import script from "./ProjectCreateModel.vue?vue&type=script&lang=js"
export * from "./ProjectCreateModel.vue?vue&type=script&lang=js"
import style0 from "./ProjectCreateModel.vue?vue&type=style&index=0&id=49b97b01&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b97b01",
  null
  
)

export default component.exports